import _ from 'lodash'

export default (objValue, srcValue) => {
  if (_.isArray(objValue)) {
    return srcValue
  }
}
